// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".two-columns .ml-primary-col[data-v-2ce6b89c] {\n  padding-right: 10px;\n  border-right: 1px solid #eee;\n}\n.two-columns .ml-secondary-col[data-v-2ce6b89c] {\n  padding-left: 10px;\n  width: 100%;\n}\n.ml-header-col[data-v-2ce6b89c] {\n  display: flex;\n  align-items: center;\n}\n.ml-header-col .ml-label[data-v-2ce6b89c] {\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
